import Footer from '../components/Footer';
import Navigation from '../components/Navigation';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/Publikationen.css';

function Publikationen() {
  window.scrollTo(0, 0);

  const publikationen = [
    {
      title: 'Monografien',
      entries: [
        {
          text: 'Helm, Gerrit (2025): Diagnostik hierarchieniedriger Leseprozesse aus linguistischer Perspektive. Peter Lang.',
          link: 'https://www.peterlang.com/free_download?document_id=1508731&product_form=ebook&publication_type=pdf',
          img: '/material/Logo_PeterLang.png'
        },
      ]
    },
    {
      title: 'Zeitschriftenbeiträge',
      entries: [
        {
          text: 'Helm, Gerrit (2026): Sprachsystematische Lesediagnostik auf Satzebene. In: Didaktik Deutsch 60.',
          link: 'https://didaktik-deutsch.de/index.php/dideu/article/view/918/778',
          img: '/material/Logo_DidaktikDeutsch.png'
        },
        {
          text: 'Helm, Gerrit & Hesse, Florian (2026): Revising with AI: aligning feedback technologies with learners’ revision processes. In: Frontiers in Education 11/2026.',
          link: 'https://www.frontiersin.org/journals/education/articles/10.3389/feduc.2026.1702406/full',
          img: '/material/Logo_Frontiers.png'
        },
        {
          text: 'Helm, Gerrit & Hesse, Florian (2026): Stop perfecting the feedback, start supporting the uptake: rethinking AI in writing instruction. In: Frontiers in Education 11/2026.',
          link: 'https://www.frontiersin.org/journals/education/articles/10.3389/feduc.2026.1737037/full',
          img: '/material/Logo_Frontiers.png'
        },
        {
          text: 'Helm, Gerrit & Hesse, Florian (2025): Lesediagnostik und Leseförderung mit KI: Aktuelle Konzepte und Anforderungen an das Professionswissen von Lehrpersonen. In: leseforum.ch 2/2025.',
          link: 'https://www.leseforum.ch/lffl/2025/2/878',
          img: '/material/Logo_leseforum.png'
        },
        {
          text: 'Helm, Gerrit (2025): Professionelle Wahrnehmung von Lernendentexten als Voraussetzung für die Reflexion KI-generierten Feedbacks. In: Leseräume 11/2025.',
          link: 'https://leseräume.de/wp-content/uploads/2025/06/Helm-2025-LR-JG12-H11.pdf',
          img: '/material/leseraume_logo.png'
        },
        {
          text: 'Hesse, Florian & Helm, Gerrit (2025): Instapoetry mit KI verfassen. In: Praxis Deutsch 311/2025. S. 37-43',
          link: '#',
          img: '/material/fv_logo_passiv.png'
        },
        {
          text: 'Dube, Juliane & Helm, Gerrit (2025): „Und dadurch fühlt man, sag ich jetzt mal, die Geschichte dazu…” Ästhetische Erfahrungen im Umgang mit Bilderbuch-Apps. In: MiDu: Medien im Deutschunterricht 2/2025. Herausgegeben von Jan Boelmann, Lisa König und Jaron Müller. S. 1-26',
          link: 'https://journals.ub.uni-koeln.de/index.php/midu/article/view/3364/3501',
          img: '/material/MiDu_logo_passiv.png'
        },
        {
          text: 'Helm, Gerrit & Hesse, Florian (2025): Training Programmes on Writing with AI – but for whom? Identifying Students’ Writer Profiles through Two-step Cluster Analysis. In: Journal of Writing Research 4/2025.',
          link: 'https://www.jowr.org/jowr/article/view/1542/998',
          img: '/material/Jowr_passiv.png'
        },
        {
          text: 'Magirius, Marco & Hesse, Florian & Helm, Gerrit & Scherf, Daniel (2024): KI im Literaturunterricht. Chancen und Herausforderungen zwei Jahre nach Veröffentlichung von ChatGPT. In: Der Deutschunterricht 5/2024. S. 14-23.',
          link: 'https://www.friedrich-verlag.de/friedrich-plus/sekundarstufe/deutsch/sprachgebrauch/ki-im-literaturunterricht-19740',
          img: '/material/fv_logo_passiv.png'
        },
        {
          text: 'Hesse, Florian & Helm, Gerrit (2024): Writing with AI in and beyond teacher education: Exploring subjective training needs of student teachers across five subjects. In: Journal of Digital Learning in Teacher Education (JDLTE). S. 1-14. https://doi.org/10.1080/21532974.2024.2431747',
          link: 'https://www.tandfonline.com/doi/full/10.1080/21532974.2024.2431747?scroll=top&needAccess=true',
          img: '/material/Taylor_and_Francis.png'
        },
        {
          text: 'Helm, Gerrit & Hesse, Florian (2024): Usage and beliefs of student teachers towards artificial intelligence in writing. In: Research in Subject-matter Teaching and Learning (RISTAL). 7 (1). S. 1-18. https://doi.org/10.2478/ristal-2024-0001',
          link: 'https://sciendo.com/de/article/10.2478/ristal-2024-0001',
          img: '/material/sciendo.png'
        },
        {
          text: 'Helm, Gerrit & Dube, Juliane (2024): Hingeschaut – Bilderbuch-Apps zum literarischen Lernen im inklusiven Deutschunterricht. In: MedienPädagogik. Zeitschrift für Theorie und Praxis der Medienbildung. https://doi.org/10.21240/mpaed/00/2024.03.16.X',
          link: 'https://www.medienpaed.com/article/view/1616',
          img: '/material/Medienpaed.png'
        },
        {
          text: 'Helm, Gerrit (2022): "Das lokomotische Satzmodell: Satztopologie im Unterricht der Primarstufe" SLLD-U.',
          link: 'https://doi.org/10.46586/SLLD.220',
          img: '/material/SLLD.png'
        }
      ]
    },
    {
        title: "Beiträge in Sammelbänden",
        entries: [
            {
            text: 'Helm, Gerrit & Hesse, Florian (2025): Umgang mit Dialekt im Deutschunterricht. Wo bleibt die Sprachbetrachtung?. In: Hochstadt, Christiane & Schweigkofler Kuhn, Anny (Hrsg.): Dialekt in der Lehre. Sprachdidaktische und varietätenlinguistische Perspektiven. Narr Francke Attempto.',
            link: 'https://www.narr.de/dialekt-in-der-lehre-1090-1/',
            img: '/material/Narr_Logo.png'
            },
            {
            text: 'Gailberger, Steffen & Helm, Gerrit (2024): kluug das Lesen fördern. Digitale systematische Leseförderung für die Grundschule. In: Carl, Mark-Oliver & Jörgens, Moritz & Schulze, Tina (Hrsg.): Literarische Texte lesen – Texte literarisch lesen. Festschrift für Cornelia Rosebrock. J.B. Metzler, S. 143-172.',
            link: 'https://link.springer.com/chapter/10.1007/978-3-662-67816-9_9',
            img: '/material/Springer.jpg'
            },
            {
            text: 'Dube, Juliane & Helm, Gerrit & Ronge, Verena (2023): Kindliches Spiel und ästhetische Erfahrungen am Beispiel von Bilderbuch-Apps. Erste Ergebnisse einer rekonstruktiven Fallstudie. In: Dichtl, Eva-Marie & Bernhardt, Sebastian (Hrsg.): Frühkindliches Spiel und literarische Rezeption. Frank & Timme, S. 153-188.',
            link: 'https://www.researchgate.net/publication/373158588_Kindliches_Spiel_und_asthetische_Erfahrungen_mit_polymodalen_Texten_am_Beispiel_von_Bilderbuch-Apps',
            img: '/material/RG.jpeg'
            },
            {
            text: 'Gailberger, Steffen & Helm, Gerrit & Nix, Daniel (2022): Lesen und Leseförderung in der Primar- und Sekundarstufe. In: Gailberger, Steffen & Wietzke, Frauke (Hrsg.): Handbuch Kompetenzorientierter Deutschunterricht. 2. Aufl. S. 38-93.',
            link: '#',
            img: ''
            },
            {
            text: 'Helm, Gerrit (2021): "Das Ausmaß der Unterschiede in den Lese-Items des Salzburger Lese-Screening 2-9" In: Gailberger, Steffen & Sappok, Christopher (Hrsg.): Weiterführende Grundlagenforschung in Lesedidaktik und Leseförderung: Theorie, Empirie, Anwendung. SLLD-B.',
            link: 'https://omp.ub.rub.de/index.php/SLLD/catalog/download/189/167/1102?inline=1',
            img: '/material/SLLD.png'
            }
        ]
    },
    {
        title: "Herausgeberschaften",
        entries: [
            {
            text: 'Hesse, Florian & Helm, Gerrit (2025): Künstliche Intelligenz im Deutschunterricht jenseits der Textproduktion. SLLD.',
            link: 'https://omp.ub.rub.de/index.php/SLLD/catalog/book/442',
            img: '/material/SLLD.png'
            }
        ]
    },
    {
        title: "Poster",
        entries: 
        [
            {
            text: 'Helm, Gerrit & Hesse, Florian (2025): "Schulen nutzen KI für Lesen, Literatur und Schreiben (SKILLS)". Poster zum 39. Arbeitstreffen der AG Medien.',
            link: 'https://www.researchgate.net/publication/390300394_Schulen_nutzen_KI_fur_Lesen_literarisches_Lernen_und_Schreiben_SKILLS',
            img: '/material/RG.jpeg'
            },
             {
            text: 'Helm, Gerrit (2024): "AiDe-L: (Browser-)Anwendung zur individuellen Diagnose im Lesen." Poster zum 8. Arbeitstreffen der AG Leseverstehen.',
            link: 'https://www.researchgate.net/publication/378434648_AiDe-L_Browser-Anwendung_zur_individuellen_Diagnose_im_Lesen_Poster_zum_8_Arbeitstreffen_der_AG_Leseverstehen_in_Koblenz',
            img: '/material/RG.jpeg'
            },
             {
            text: 'Helm, Gerrit (2018): "Ein Modell des hierarchischen Lesens und seine lesedidaktischen Implikationen." Poster zum 22. Symposion Deutschdidaktik.',
            link: '#',
            
            }
        ]
    },
    {
        title: "Rezensionen",
        entries: [
            
            {
            text: 'Hesse Florian & Helm, Gerrit (2025): "Hazelight Studio: Split Fiction" [Rezension]: KinderundJugendmedien.de.',
            link: 'https://www.kinderundjugendmedien.de/kritik/computerspiele/7447-hazelight-studio-split-fiction',
            img: '/material/KinderundJugendMedien.png'
            },
            
            {
            text: 'Hesse Florian & Helm, Gerrit (2024): "Rundisc: Chants of Sennaar" [Rezension]: KinderundJugendmedien.de.',
            link: 'https://www.kinderundjugendmedien.de/kritik/computerspiele/7152-rundisc-chants-of-sennar',
            img: '/material/KinderundJugendMedien.png'
            },

            {
            text: 'Hesse Florian & Helm, Gerrit (2024): "Black Salt Games: Dregde" [Rezension]: KinderundJugendmedien.de.',
            link: 'https://www.kinderundjugendmedien.de/kritik/computerspiele/7223-black-salt-games-dregde',
            img: '/material/KinderundJugendMedien.png'
            },
        ]
    },
    {
      title: 'Vorträge (ausgewählte)',
      entries: [
        { text: '13.02.2025: [Gemeinsam mit Florian Hesse] Lesen mit KI: Eine Kartierung der professionellen Kompetenzen für den Einsatz von KI in der Lesediagnostik und Leseförderung (Vortrag auf dem 9. Arbeitstreffen der SDD-AG Leseverstehen in Regensburg)' },
        { text: '15.11.2024: [Gemeinsam mit Kirsten Schindler & Alyssa Kutzner] Schreiben mit KI - Perspektiven für die Schule (Keynote beim Zukunftsforum Bildungsforschung 2024)' },
        { text: '5.11.2024: [Gemeinsam mit Florian Hesse] Schreiben mit KI an der Hochschule: Status Quo und Perspektiven nach zwei Jahren ChatGPT (Jahrestagung 2024 des eTeach-Netzwerks Thüringen)' },
        { text: '18.09.2024: KI als Ressource zum Verfassen professioneller Schreibprodukte im Lehramtsstudium (25. Symposion Deutschdidaktik)' },
        { text: '1.07.2024: Self-regulated exploration in educational videogames (Di.ge.LL-Conference Freiburg)' },
        { text: '21.06.2024: Sprachsystematische Lesediagnose und der Transfer in die Leseförderung (1. SDD Postdoc-Akademie, FSU Jena)' },
        { text: '16.03.2023: [Gemeinsam mit Juliane Dube] Ästhetische Erfahrungen im Umgang mit Bilderbuch-Apps (Jahrestagung der AG Medien des Symposion Deutschdidaktik e. V. an der Pädagogischen Hochschule Freiburg)' },
        { text: '18.01.2020: Das Erfassen von orthographischen Fertigkeiten von Schülerinnen und Schülern mit Hilfe einer Android-App (FORTE Tagung, Universität Bremen)' },
        { text: '17.01.2020: Lesekompetenz und Lesediagnose (Gastvortrag an der Leuphana Universität Lüneburg)' },
        { text: '8.12.2018: Lesekompetenz und Lesediagnose aus linguistischer Perspektive: Die Graphem-Ebene (11. Nordwestdeutsches Linguistisches Kolloquium, C.v.O Universität Oldenburg)' }
      ]
    },
    {
      title: 'Workshops und Fortbildungen',
      entries: [
        { text: '7.11.2024: Feedback mit KI im Lehramt (Workshop im Rahmen des 1. Jenaer Fachtags Deutsch)' },
        { text: '17.10.2024: Leseförderung im Kontext von Schulentfremdung (Fortbildung für Fachberater:innen im Auftrag des ThILLM)' },
        { text: '12.03.2024: Verben, Kasus, Satzglieder (Fortbildung am Studienseminar Gym/GHRS Oldenburg)' },
        { text: '19.10.2023: [Gemeinsam mit Florian Hesse] Schreiben mit KI (Fortbildung im Rahmen der Netzwerktagung Lehrer:innenbildung der FSU Jena)' },
        { text: '11.10.2022: Systematische Leseförderung von der Segmentebene bis zur Ebene des Textes (Fortbildung am Studienseminar Gym/GHRS Oldenburg)' },
        { text: '11.11.2021: Von "Tu-Wörtern", "Namen-Wörtern" und warum sie nicht so heißen sollten (Fortbildung am Studienseminar Gym/GHRS Oldenburg)' },
        { text: '19.11.2020: "Wörtervengers" - Vom Verb zu den Satzgliedern (Fortbildung am Studienseminar Gym/GHRS Oldenburg)' },
        { text: '20.02.2020: Von "Tu-Wörtern", "Namen-Wörtern" und warum sie nicht so heißen sollten (Fortbildung am Studienseminar Gym/GHRS Oldenburg)' },
        { text: '9.09.2018: vom Wort zum Satz - form-funktionaler Grammatikunterricht in der Primarstufe - Teil 2: Satzarten und Satzglieder (Fortbildung am Studienseminar GHRS Oldenburg)' },
        { text: '30.08.2018: vom Wort zum Satz - form-funktionaler Grammatikunterricht in der Primarstufe - Teil 1: Die Wortarten (Fortbildung am Studienseminar GHRS Oldenburg)' },
        { text: '9.01.2018: Sprache und Gewalt in Reinke Fuchs - Mittelalterliche Literatur und Poetry Slam (Fortbildung am Studienseminar GHRS Lüneburg)' },
        { text: '7.05.2013: Reineke der Fuchs - Mittelalterliche Literatur und HipHop im Deutschunterricht der Klassen 3-10 (Fortbildung am Studienseminar GHRS Lüneburg)' }
      ]
    },
    {
        title: 'Sonstiges',
        entries: [
            {
                text: 'Helm, Gerrit (2024): Bericht über die Sektion „Schreiben und Schreibkompetenz in Zeiten von KI“. In: Mitgliederbrief des Symposion Deutschdidaktik Nr. 81. S.16–18.'
            },
            {
                text: 'Helm, Gerrit (2022): "Van den vos Reynaerde - Didaktische Aspekte" [Vorwort zu]: Schlusemann, Rita (Hrsg.): Van den vos Reynaerde. Relectiones. Hirzel Verlag.'
            }
        ]
    }
  ];

  return (
    <>
    <Navigation />
    <div style={{ backgroundImage: 'url(/material/wand.jpg)', backgroundRepeat: 'repeat', minHeight: '100vh' }}>
    
      
      <div className="container py-5">
        <h1 className="display-5 text-center mb-4 mt-5">Publikationen</h1>
        <div className="card shadow rounded p-4" style={{ backgroundColor: '#fefefe' }}>
          {publikationen.map((section, index) => (
            <div key={index} className="mb-5">
              <h2 className="h4 border-bottom pb-2 mb-3">{section.title}</h2>
              <ul className="list-unstyled">
                {section.entries.map((entry, i) => (
                  <li key={i} className="mb-4">
                    <div className="row g-3 align-items-center">
                      <div className="col-md-10">
                        <div className="d-flex">
                          <span className="me-2">•</span>
                          <div>
                            <p className="mb-1">{entry.text}</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-2 text-end">
                         <a href={entry.link}>
                        {entry.img && (
                          <img
                            src={entry.img}
                            alt="Verlagslogo"
                            className="img-fluid hover-switch"
                            style={{ maxHeight: '50px', objectFit: 'contain', cursor: 'pointer' }}
                          />
                        )}
                        </a>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
    </>
  );
}

export default Publikationen;